import isEmpty from 'lodash/isEmpty';
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Input from '@Components/Input';
import MultiInputPill from './MultiInputPill';

import './MultiInput.custom.scss';
import './MultiInput.theme.scss';

export default class MultiInput extends React.PureComponent {
  render() {
    const {
      values,
      multiInputOnRemove,
      createdRef,
      inputValue,
      inputOnChange,
      validationMessage,
      className,
      classNameInput,
      animatedPlaceholder,
      placeholder,
      disabled,
      additionDisabled,
      ...otherInputProps
    } = this.props;

    return (
      <div className="els-multi-input-container">
        <div
          className={classnames([
            'els-multi-input',
            {
              invalid: validationMessage,
              disabled,
            },
          ])}
          ref={createdRef}>
          {!isEmpty(values) &&
            values.map((item, index) => (
              <MultiInputPill
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                value={item.value}
                onRemove={() => multiInputOnRemove(index)}
                disabled={item.disabled || disabled}
              />
            ))}
          <Input
            id="id-multi-input-input"
            className={classnames(['els-multi-input-input-component', className])}
            classNameInput={classnames(['els-multi-input-input-element', classNameInput])}
            value={inputValue}
            onChange={inputOnChange}
            animatedPlaceholder={animatedPlaceholder && isEmpty(values)}
            placeholder={isEmpty(values) ? placeholder : null}
            disabled={disabled || additionDisabled}
            {...otherInputProps}
          />
        </div>
        {validationMessage && <div className="els-multi-input-validation-message">{validationMessage}</div>}
      </div>
    );
  }
}

MultiInput.propTypes = {
  // props
  values: PropTypes.array,
  multiInputOnSelect: PropTypes.func.isRequired,
  multiInputOnRemove: PropTypes.func.isRequired,
  multiInputValidateOnChange: PropTypes.func,
  multiInputValidateOnSelect: PropTypes.func,
  disabled: PropTypes.bool,
  additionDisabled: PropTypes.bool,

  // HOCs
  createdRef: PropTypes.object.isRequired, // withCreatedRef HOC
  inputValue: PropTypes.string, // withMultiInputStateHandlers HOC
  inputOnChange: PropTypes.func.isRequired, // withInputValueOnChange HOC
  validationMessage: PropTypes.string, // withMultiInputStateHandlers HOC

  // Input props
  className: PropTypes.string,
  classNameInput: PropTypes.string,
  placeholder: PropTypes.string,
  animatedPlaceholder: PropTypes.bool,
  clearButton: PropTypes.bool,
  debounceDelay: PropTypes.number,
};

MultiInput.defaultProps = {
  animatedPlaceholder: true,
  clearButton: false,
  debounceDelay: 0,
  disabled: false,
  additionDisabled: false,
};
